import {PERCENT} from "../config/constants/Campaign/campaign_constants";

export const deep_value = (obj, path) => {
  return path
    .replace(/\[|\]\.?/g, '.')
    .split('.')
    .filter(s => s)
    .reduce((acc, val) => {
      return acc && val && acc[val]
    }, obj);
};

export const getErrorClassCouponProductsAtLeastOneGreaterThan0 = (formikProps) => {
  if (!formikProps) {
    return false
  }

  const errorMessageId = "fields.campaignManagement.productList.coupon_products.at_least_one_value_positive";

  return formikProps && formikProps.errors && formikProps.errors.coupon_products
    && formikProps.errors.coupon_products.props
    && formikProps.errors.coupon_products.props.id === errorMessageId;
}

export const getErrorClassCouponProducts = (formikProps, fieldName) => {
  if (formikProps && formikProps.touched && deep_value(formikProps.touched, fieldName) !== undefined) {
    if ((formikProps.errors && deep_value(formikProps.errors, fieldName) !== undefined) || getErrorClassCouponProductsAtLeastOneGreaterThan0(formikProps)) {
      return 'custom-is-invalid';
    }
  }

  return '';
}

export const getProductName = (translations, lang) => {
  let productName = "";
  translations.forEach(translation => {
    if (translation.language.short_name === lang) {
      productName = translation.name;
    }
  })

  return productName;
}

export const getItemPrice = (productGroups, selectedProductGroup, selectedProduct) => {
  let price = 0;

  if (!productGroups || !productGroups.length) {
    return price;
  }

  productGroups.forEach((productGroupsItem, productGroupsIndex) => {
    if (productGroupsItem.id === selectedProduct) {
      productGroupsItem.products.forEach((productItem, productIndex) => {
        if (selectedProductGroup === productItem.id) {
          price = productItem.price;
        }
      });
    }
  });

  return price;
}

export const getItemCurrency = (productGroups, selectedProductGroup, selectedProduct) => {
  let currency = 'EUR';

  productGroups.forEach((productGroupsItem, productGroupsIndex) => {
    if (productGroupsItem.id === selectedProduct) {
      productGroupsItem.products.forEach((productItem, productIndex) => {
        if (selectedProductGroup === productItem.id) {
          currency = productItem.currency;
        }
      });
    }
  });

  return currency;
}

export const getFinalPrice = (price, discountValue, discountType, index) => {
  let finalPrice = parseFloat(price);

  if (discountType === PERCENT) {
    return (finalPrice - (finalPrice * (parseFloat(discountValue[index] ? discountValue[index] : 0) / 100))).toFixed(3);
  }

  return (finalPrice - parseFloat(discountValue[index])).toFixed(3);
}
